import { format } from "date-fns";

const generateCalendarLinks = (lastPurchase, purchasedSession) => {
    if (!lastPurchase || !lastPurchase.sessionDate) {
        return null;
    }

    const { sessionDate, movie_title, venue_name, venue_address, venue_suburb } = lastPurchase;

    const sessionDateTime = new Date(sessionDate);
    const durationMinutes = purchasedSession?.running_time || 120;
    const endDateTime = new Date(sessionDateTime.getTime() + durationMinutes * 60 * 1000);

    const formatForCalendar = (date) => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        const seconds = String(date.getUTCSeconds()).padStart(2, "0");
        return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
    };

    const startTime = formatForCalendar(sessionDateTime);
    const endTime = formatForCalendar(endDateTime);

    const title = encodeURIComponent(movie_title || "Movie");
    const location = encodeURIComponent(`${venue_name || ""}, ${venue_address || ""}, ${venue_suburb || ""}`);
    const description = encodeURIComponent(`Movie: ${movie_title || ""} at ${venue_name || ""}`);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Australia/Melbourne";

    return {
        google: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startTime}/${endTime}&details=${description}&location=${location}`,

        outlook: `https://outlook.live.com/calendar/0/deeplink/compose?subject=${title}&startdt=${startTime}&enddt=${endTime}&body=${description}&location=${location}`,

        ical: generateICalFile(movie_title || "Movie", sessionDateTime, endDateTime, `${venue_name || ""}, ${venue_address || ""}, ${venue_suburb || ""}`, timezone),

        yahoo: `https://calendar.yahoo.com/?v=60&title=${title}&st=${startTime}&et=${endTime}&desc=${description}&in_loc=${location}`
    };
};

const generateICalFile = (title, startDate, endDate, location, timezone) => {
    const formatICalDate = (date) => {
        return format(date, "yyyyMMdd'T'HHmmss");
    };

    const icalContent = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODNAME:-//Choovie//Movie Ticket//EN",
        "BEGIN:VEVENT",
        `DTSTART;TZID=${timezone}:${formatICalDate(startDate)}`,
        `DTEND;TZID=${timezone}:${formatICalDate(endDate)}`,
        `SUMMARY:${title}`,
        `LOCATION:${location}`,
        `DESCRIPTION:${title}`,
        "END:VEVENT",
        "END:VCALENDAR"
    ].join("\r\n");

    return `data:text/calendar;charset=utf-8,${encodeURIComponent(icalContent)}`;
};

export { generateCalendarLinks, generateICalFile };
